import { WaterSyncIcon } from './WaterSyncIcon';

/**
 * author: Hans Böhm
 * id 14D06EC0-32F9-4CCE-B890-89DE73A106EA
 * name water-sync
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/water-sync.svg
 * tags
 * - Agriculture 
 */
export const WaterRecycleIcon = WaterSyncIcon;
export default WaterRecycleIcon